(function () {
  function toNum(v) {
    if (v == null) return NaN;
    var s = String(v).trim().replace(',', '.');
    s = s.replace(/[^0-9.]/g, '');
    return parseFloat(s);
  }

  function sortSizeSwatches() {
    document.querySelectorAll('.tt-swatches-container .tt-wrapper').forEach(function (wrapper) {
      var titleEl = wrapper.querySelector('.tt-title-options');
      if (!titleEl) return;

      // Match "Size:" exactly, avoids sorting Colour etc
      var titleText = titleEl.textContent || '';
      if (!/^\s*Size\s*:/i.test(titleText)) return;

      var ul = wrapper.querySelector('ul.tt-options-swatch');
      if (!ul) return;

      var items = Array.prototype.slice.call(ul.querySelectorAll(':scope > li'));
      if (items.length < 2) return;

      // Only sort if at least 2 values parse as numbers
      var numericCount = 0;
      items.forEach(function (li) {
        var a = li.querySelector('a');
        var val = a ? (a.getAttribute('data-value') || a.textContent) : li.textContent;
        if (!Number.isNaN(toNum(val))) numericCount++;
      });
      if (numericCount < 2) return;

      items.sort(function (liA, liB) {
        var aA = liA.querySelector('a');
        var aB = liB.querySelector('a');
        var vA = aA ? (aA.getAttribute('data-value') || aA.textContent) : liA.textContent;
        var vB = aB ? (aB.getAttribute('data-value') || aB.textContent) : liB.textContent;
        return toNum(vA) - toNum(vB);
      });

      items.forEach(function (li) { ul.appendChild(li); });
    });
  }

  document.addEventListener('DOMContentLoaded', sortSizeSwatches);
  document.addEventListener('shopify:section:load', sortSizeSwatches);
})();